export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/78489dd5fe22b2b724f99f5861a7cee7.svg";